import React from "react";
import { Card, Table } from "antd";
import { observer } from "mobx-react";
import { fmtDateTime, fmtMoney2 } from "../../../common/Utils";
import { Store } from "../../../store/Store";
import { UserLink } from "../../../components/UserLink/UserLink";

export const DonateTable2 = observer(() => {
  const { fundView } = Store.fundsStore;

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Name",
      key: "inviteName",
      render: (_, r) => {
        if (r.inviteName) {
          return r.inviteName;
        } else {
          return r.user && <UserLink name={r.user.name} userId={r.user.id}></UserLink>;
        }
      },
    },
    {
      title: "Child Name",
      key: "childName",
      dataIndex: ["child", "name"],
      // sorter: (a, b) => a.child.name.toLocaleLowerCase().localeCompare(b.child.name.toLocaleLowerCase()),
    },
    {
      title: "Invite Family & Friends",
      key: "invite",
      render: (_, r) => (r.inviteName ? "Yes" : "No"),
    },
    {
      title: "Invitation From",
      key: "from",
      render: (_, r) => r.inviteName && r.user && <UserLink name={r.user.name} userId={r.user.id}></UserLink>,
    },
    {
      title: "Donation / Goal",
      key: "pergoal",
      dataIndex: "goal",
    },
    {
      title: "# of Goals Achieved",
      key: "count",
      dataIndex: "count",
    },
    {
      title: "Amount",
      key: "amount",
      render: (_, r) => (fundView.fund?.complete ? fmtMoney2((r.amount || 0) / 100.0) : ""),
    },
    {
      title: "Time",
      dataIndex: "createDate",
      key: "createDate",
      width: 160,
      render: (v) => fmtDateTime(v),
    },
  ];

  return (
    <Card size="small" bodyStyle={{ padding: 0 }} title={`Total Amount: ${fundView.totalAmount}`}>
      <Table rowKey="id" size="small" columns={columns} dataSource={fundView.donates} pagination={false}></Table>
    </Card>
  );
});
